var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowVertical = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 70,
  fill: "none",
  viewBox: "0 0 33 75"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M27.883 3.337c-6.91-.445-21.477 3.91-24.465 24.886-3.735 26.22 18.601 37.355 25.013 40.91m.2-8.278L30 71.203 19.79 72.22"
})));
export { SvgArrowVertical as ReactComponent };